<template>
  <div>
    <img class="bg1" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-bg1.jpg')" />
    <div class="container">
      <div class="info-1">
        <div>
          <img class="info-1-bg" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-1-bg.png')" alt="" />
        </div>
        <div class="info-1-text">
          <div class="info-1-text-1">目前获得<span class="info-1-text-3">{{clientQrPoint + activityPoint}}</span>积分</div>
          <div class="info-1-text-2">(其中{{activityPoint}}积分为活动积分，有效期至2022年7月31日)</div>
        </div>
        <img class="info-1-icon" @click="gotoWeb('cart')" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-1-icon.png')" />
      </div>
      <div class="info-2">
        <div class="img-list-1">
          <img v-if="Number(scanCount)<20" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status1-1.png')">
          <img v-if="Number(scanCount)>=20" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status1-2.png')">
          <img v-if="Number(scanCount)<40" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status2-1.png')">
          <img v-if="Number(scanCount)>=40" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status2-2.png')">
          <img v-if="Number(scanCount)<50" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status3-1.png')">
          <img v-if="Number(scanCount)>=50" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status3-2.png')">
        </div>
        <van-progress :pivot-text="String(scanCount)" color="#F7E3A1" :percentage="Number(scanCount)*1.5<90?String(Number(scanCount)*1.5):'90'" />
        <div class="img-list-1">
          <img v-if="Number(scanCount)<20" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status1-3.png')">
          <img v-if="Number(scanCount)>=20" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status1-4.png')">
          <img v-if="Number(scanCount)<40" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status2-3.png')">
          <img v-if="Number(scanCount)>=40" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status2-4.png')">
          <img v-if="Number(scanCount)<50" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status3-3.png')">
          <img v-if="Number(scanCount)>=50" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-2-status3-4.png')">
        </div>
      </div>

      <div class="tip">新用户前5次扫码可额外获得1000积分</div>
      <div class="tip">注：以上积分为累计获得</div>

      <div class="info-3">
        <img class="info-3-bg" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-3-bg.png')" />
        <div class="info-3-text">
          <div class="info-3-text-1">当前已扫码<span class="info-3-text-2">{{scanCount}}</span>次</div>
          <img @click="handleScan()" class="info-3-btn" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-3-btn.png')" />
        </div>
      </div>
      <div class="info-4" >
        <img class="title-img" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-title.png')" />
        <img class="info-4-bg" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-bg.png')" alt="" />
        <div class="rank-box" v-if="showRank">
          <div class="rank-item">
            <img :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank1.png')" />
            <span class="info-4-clientName">{{activityScanList[0]?activityScanList[0].clientName:''}}</span>
            <span>{{activityScanList[0]?activityScanList[0].bonusCount:''}}次</span>
          </div>
          <div class="rank-item" v-if="activityScanList.length>1">
            <img :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank2.png')" />
            <span class="info-4-clientName">{{activityScanList[1]?activityScanList[1].clientName:''}}</span>
            <span>{{activityScanList[1]?activityScanList[1].bonusCount:''}}次</span>
          </div>
          <div class="rank-item" v-if="activityScanList.length>2">
            <img :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-4-rank3.png')" />
            <span class="info-4-clientName">{{activityScanList[2]?activityScanList[2].clientName:''}}</span>
            <span>{{activityScanList[2]?activityScanList[2].bonusCount:''}}次</span>
          </div>
        </div>
        <div class="no-rank" v-else>
          <div class="no-rank-text">暂无数据</div>
        </div>
        <div  v-if="showRank" class="show-more" @click="gotoWeb('rank')">点击查看更多</div>
      </div>

      <div class="info-5">
        <img class="title-img" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-5-title.png')" />
        <img class="info-5-bg" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-5-bg.png')" alt="" />
        <div class="item-box">
          <div class="item-detail" v-for="(item,index) of itemList" :key="index" @click="gotoWeb('shop',item.itemId)">
            <!-- <img :src="process.env.VUE_APP_FILE_SERVER+item.imageUri" /> -->
            <img class="item-img" :src="getImageUrl(item.itemImageUri)" />
            <div class="item-info">
              <div><span class="item-discount">折扣</span>{{item.itemName}}</div>
              <div>
                <div class="item-price-after"><span class="item-price-after-sp">{{item.promotionPoint}}</span>积分</div>
                <div class="item-price-before">{{item.basePoint}}积分</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <van-overlay :show="showdialog" @click="handleCloseDialog()">
        <div class="wrapper" @click.stop>
          <img class="dialog-bg" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-dialog.png')" />
          <div class="prize-name">{{prize}}</div>
          <img class="dialog-btn" @click="handleScan()" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-dialog-btn.png')" />
        </div>
      </van-overlay>
      <div class="info-detail-box">
        <img class="info-detail" :src="$getImgUrl('/img/activity/2022-scan/2022-scan-info-detail.png')"/>
      </div>

      <div class="detail-text">
       <div>①活动期间，凡是扫博世产品二维码满一定次
   数，即可获得额外的积分奖励；</div>
   <div>②扫满<span class="color-red">20次</span>可获得<span class="color-red">1888</span>积分；扫满<span class="color-red">40次</span>可获得<span class="color-red">3888</span>积分；扫满<span class="color-red">50次</span>将获得<span class="color-red">6276</span>积
   分（此处积分均为累计积分）；</div>
<div>③新用户前5次扫码可额外获得<span class="color-red">1000积分</span>；</div>
<div>④整个活动期内，累计扫码数排行前3的用户
   可获得<span class="color-red">18888、66666、88888</span>的易加积分
   奖励；</div>
<div>⑤部分活动积分有效期至2022年7月31日，积
   分明细请查阅【我的积分】；</div>
<div>⑥本活动最终解释权归博世易加所有。</div>

      </div>

      <div class="block"></div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import activityApi from '@/api/activity'
import { Dialog } from 'vant'
export default {
  data () {
    return {
      itemList: [],
      activityPoint: 0,
      clientQrPoint: 0,
      scanCount: '0',
      activityScanList: [],
      showdialog: false,
      prize: '',
      showRank: false
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo() || ''
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })

    this.getItemList()
    this.getRankInfo()
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  methods: {
    getRankInfo () {
      activityApi.get2022ScanRankingInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.activityScanList = res.data.resultData.activityScanList || []
          if (this.activityScanList.length !== 0) {
            this.showRank = true
          }
          this.activityPoint = res.data.resultData.activityPoint || 0
          this.scanCount = res.data.resultData.scanCount || 0
          this.clientQrPoint = res.data.resultData.clientQrPoint || 0
        }
        if (this.activityScanList === []) {
          this.showRank = false
        }
      })
    },
    getItemList () {
      activityApi.get2022ScanItemList().then(res => {
        if (res.data.resultCode === '0') {
          this.itemList = res.data.resultData.itemList
        }
      })
    },
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    getImgUrl (imageUri) {
      return process.env.VUE_APP_FILE_SERVER + imageUri
    },
    handleCloseDialog () {
      this.showdialog = false
      this.getRankInfo()
    },
    gotoWeb (type, itemId) {
      if (type === 'rank') {
        this.$router.push({ name: 'activity-2022-scan-rank' })
      } else if (type === 'shop') {
        window.location.href = commonUtils.getExtraSite() + `/#/goodsDetail/${itemId}`
      } else if (type === 'cart') {
        window.location.href = commonUtils.getExtraSite() + `/#/tab/cart`
      }
      // window.location.href = commonUtils.getExtraSite()
    },
    handleScan () {
      // 测试
      // let code = {
      //   // scanCode: 'S94VYRB6P7TJWFRDH4'
      //   scanCode: 'https://QR.BOSCH-EXTRA.COM.CN/QY8QR8TTW1YMVNRQYQ'
      // }
      // this.scanResult(code)
      // return
      // this.scanResult(code)
      // if (!this.clientInfo) {
      //   window.location.href = commonUtils.getExtraSite() + '/#/login' + '?redirectUrl'
      // }
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData = {
            scanCode: res.resultStr
          }
          this.getLocation(scanData)
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },
    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.scanResult(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    scanResult (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.scanFirstHalf2022(value).then(res => {
        this.$toast.clear()
        console.log(res)
        if (res.data.resultCode === '0') {
          if (res.data.resultData.activityPointValue) {
            this.prize = res.data.resultData.activityPointValue
            this.showdialog = true
          }
          this.getItemList()
          Dialog.confirm({
            message: '恭喜你扫码成功！',
            showCancelButton: false
          })
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }

  }
}
</script>

<style lang="less" scoped>
.bg1 {
  width: 100%;
}
.container {
  background-image: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/2022-scan/2022-scan-bg2.jpg"), url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/2022-scan/2022-scan-bg3.jpg"),
    url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/2022-scan/2022-scan-bg4.jpg");
  background-size: 100%, 100% 100%;
}
.info-1 {
  height: 70px;
  margin-top: -5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  .info-1-bg {
    //height: 60px;
    width: 81vw;
  }
  .info-1-icon {
    width: 66px;
    height: 66px;
    margin-right: 20px;
  }
  .info-1-text {
    position: absolute;
    top: 5px;
    //left: 10px;
    .info-1-text-1{
      font-size: 18px;
      transform: scale(0.9);
    }
    .info-1-text-2{
      font-size: 12px;
      margin-top: 5px;
      transform: scale(0.9);
    }
    .info-1-text-3{
      font-size: 25px;
      color: rgb(223, 0, 0);
    }
  }
}
.info-2{
  margin: 30px 0;
  .img-list-1{
    display: flex;
    justify-content: space-evenly;
    margin: 20px 0;
    img{
      width: 75px;
    }

  }
}
.info-3 {
  position: relative;
  text-align: center;
  margin-top: 20px;
  .info-3-bg {
    width: 90%;
  }
  .info-3-text {
    top: -130px;
    position: relative;
    .info-3-text-1{
      font-size: 20px;
      margin-bottom: 20px;
    }
    .info-3-text-2{
      color: rgb(243, 0, 0);
      font-size: 25px;
      font-weight: 600;
      margin: 0 3px;
    }
  }
  .info-3-btn {
    width: 160px;
  }
}
.info-4 {
  position: relative;
  text-align: center;
  margin-top: -70px;
  .title-img {
    width: 150px;
  }
  .info-4-bg {
    margin-top: 10px;
    width: 90%;
  }
  .rank-box {
    position: relative;
    top: -205px;
    height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .rank-item {
    //margin-bottom: 25px;
    width: 88%;
    margin-left: 6%;
    align-items: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
    img {
      width: 35px;
    }
    .img-sp{
      width: 63px;
    }
    .info-4-clientName{
      width: 150px;
    }
  }
  .show-more {
    color: white;
    position: relative;
    top: -195px;
  }
}
.info-5 {
  text-align: center;
  margin-top: -130px;
  position: relative;
  .title-img {
    width: 240px;
  }
  .info-5-bg {
    margin-top: 10px;
    width: 90%;
  }
  .item-box{
    width: 80%;
    margin-left: 11.5%;
    height:390px;
    position: absolute;
    top:70px;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
    overflow-x: hidden;
    .item-detail{
      border: 1px solid rgb(189, 189, 189);
      border-radius: 10px;
      margin: 10px 8px 0 0 ;
      width: calc(49% - 8px);
      min-height: 230px;
      //max-height: 220px;
      font-size: 14px;
      text-align: left;
    }
    .item-img{
      width: 100%;
    }
    .item-discount{
      background-color: rgb(218, 0, 0);
      color: rgb(255, 255, 255);
      border-radius: 5px;
      padding: 0 3px;
      font-size: 12px;
      margin-right: 2px;
      transform: scale(0.86);
    }
    .item-info{
      width: 92%;
      margin-left: 4%;
    }
    .item-price-after{
      color: rgb(247, 0, 0);
    }
    .item-price-after-sp{
      font-size: 20px;
    }
    .item-price-before{
      margin-left: 3px;
      color: grey;
     text-decoration:line-through;
    }
  }
}
.info-detail{
  margin: 30px 5% 20px 5%;
  width: 90%;
  object-fit: cover;
  flex: 0%;
 //clip:rect(top right bottom left);
}
.info-detail-box{
  width: 100%;
    height: 60px;
    overflow: hidden;
}
.wrapper{
  text-align: center;
}
.dialog-bg{
  margin-top: 50px;
  width: 100%;
}
.prize-name{
  color: red;
  font-size: 20px;
  position: relative;
  top: -230px;
}
.dialog-btn{
  width: 150px;
  position: relative;
  top: -120px;
}
.tip{
  text-align: center;
  font-size: 12px;
  line-height: 17px;
}
.detail-text{
  position: relative;
  width: 90%;
  margin: 0 5% ;
  font-size: 16px;
  line-height: 25px;

}
.color-red{
  color: rgb(237, 0, 0);
}
.block{
  width: 100%;
  height: 20px;
}
.no-rank{
  height:185px;
  text-align: center;
  //align-items: center;
}
.no-rank-text{
  position: relative;
  top: -140px;
}
</style>
